import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PrivateRoute } from '../../elements';
import { ActionsPage } from '../actions';
import { AdminPage } from '../admin';
import { QaMatrixPage } from '../qa-matrix/index';
import { LoginPage, LoginPasswordPage, LogoutPage, SessionPage, UnauthorizedPage } from '../auth';
import { UserContext } from '../contexts';
import { HelpPage } from '../help';
import { HomePage } from '../home';

export function Routes() {
  const { user } = useContext(UserContext);
  const isUser = () => user !== undefined;

  return (
    <Switch>
      <Route exact path="/session" component={SessionPage} />
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/login-password" component={LoginPasswordPage} />
      <Route exact path="/logout" component={LogoutPage} />
      <Route exact path="/unauthorized" component={UnauthorizedPage} />
      <Route exact path="/help" component={HelpPage} />
      <Route exact path="/help/documents" component={HelpPage} />
      <PrivateRoute exact path="/" component={HomePage} canOpen={isUser} />
      <PrivateRoute exact path="/actions" component={ActionsPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/users" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/roles" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/roles/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/system-settings" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/notification-types" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/error-statuses" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/error-codes" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/error-finders" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/countries" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/four-ms" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/costs" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/frequencies" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/customer-classes" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/equipments" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/production-sites" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/suppliers" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/qa-matrix" component={QaMatrixPage} canOpen={isUser} />
    </Switch>
  );
}
